import React from 'react'
import { Link } from 'react-router-dom'

import { GoArrowDownRight } from 'react-icons/go'

export default function Hero() {
  return (
    <div className='hero bg-black md:h-[710px] h-[350px] flex flex-col justify-center items-center md:space-y-10 space-y-5 px-5 '>
      <h1 className='lg:text-[140px] md:text-[120px] text-6xl text-center animate__rubberBand wow animate__animated'>
        DEEP <br /> WHALES AI
      </h1>
      <p className='md:text-xl text-base animate__rubberBand wow animate__animated'>
        Giving users an almost unfair advantage
      </p>
      <div className='flex items-center gap-3  '>
        <a
          href=''
          className='animate__zoomIn wow animate__animated border-2 flex items-center gap-1 group border-[#D2A42C] bg-black md:py-3 py-2 md:px-10 px-5 md:text-xl text-lg rounded-2xl transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-105  duration-300'
        >
          Buy Now
          <GoArrowDownRight className='group-hover:translate-x-4 transition ease-in-out delay-150 duration-300' />
        </a>
        <a
          href=''
          className='animate__zoomIn wow animate__animated bg-[#1F1F1F] rounded-2xl md:py-3.5 py-2 md:px-14 px-6 md:text-xl text-lg transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-105  duration-300 hover:bg-white hover:text-black'
        >
          Chart
        </a>
      </div>
    </div>
  )
}
